const womenImg = require("../assets/images/women.webp");
const menImg = require("../assets/images/men.png");
const pathFinderLogo = require("../assets/images/logo-path-finder.webp");
const universityImg = require("../assets/images/university-img-min.webp");
const laptopImg = require("../assets/images/laptopImg.webp");
const roundGreenRect = require("../assets/images/round-green-rect.webp");
const landingPhoto1 = require("../assets/images/timeChnaged.jpg");
const progressImg1 = require("../assets/images/progress-img1.webp");
const progressChartImg1 = require("../assets/images/progress-chart-img.webp");
const footerlogo = require("../assets/images/footer-logo.webp");
const holisticImg = require("../assets/images/holistic.jpg");
const resumeWorkImg = require("../assets/images/resumeWork.jpg");
const backgroundVideo = require("../assets/images/resume-builder-video-1080p.mp4");
const redBucket = require("../assets/images/red_bucket.png");
const dashboard_icon = require("../assets/images/dashboard_icon.png");
const journey_icon = require("../assets/images/journey_icon.png");
const story_icon = require("../assets/images/story_icon.png");
const universities_icon = require("../assets/images/universities_icon.png");
const Scholarship_icon = require("../assets/images/Scholarship_icon.png");
const profile_icon = require("../assets/images/profile_icon.png");
const logout_icon = require("../assets/images/logout_icon.png");
const notification_icon = require("../assets/images/notification.png");
const no_notification_icon = require("../assets/images/gray-bell.png");
const chevron_down_icon = require("../assets/images/chevron-down.png");
const frame1_icon = require("../assets/images/Frame-1.png");
const frame2_icon = require("../assets/images/Frame-2.png");
const frame3_icon = require("../assets/images/Frame-3.png");
const frame4_icon = require("../assets/images/Frame-4.png");
const news_icon = require("../assets/images/speaker.png");
const Vector_icon = require("../assets/images/Vector.png");
const chevron_icon = require("../assets/images/chevron-right.png");
const arrow_icon = require("../assets/images/arrow-right.png");
const Mask_group_icon = require("../assets/images/Mask.png");
const group9_icon = require("../assets/images/Group-9.png");
const new_icon = require("../assets/images/news_iocn.png");
const mic_icon = require("../assets/images/micImg.png");

const grid_icon = require("../assets/images/grid.svg");
const user_icon = require("../assets/images/user.svg");
const Group_icon = require("../assets/images/Group 1000002795.svg");
const map_icon = require("../assets/images/map.svg");
const clip_icon = require("../assets/images/clipboard.svg");
const student_icon = require("../assets/images/student-1.svg");
const logout_icon_svg = require("../assets/images/logout.svg");
const news_icon_svg = require("../assets/images/news_icon_svg.svg");
















export {
  footerlogo,
  womenImg,
  menImg,
  progressChartImg1,
  progressImg1,
  landingPhoto1,
  pathFinderLogo,
  roundGreenRect,
  laptopImg,
  universityImg,
  backgroundVideo,
  holisticImg,
  resumeWorkImg,
  redBucket,
  dashboard_icon,
  journey_icon,
  story_icon,
  universities_icon,
  Scholarship_icon,
  profile_icon,
  logout_icon,
  notification_icon,
  no_notification_icon,
  chevron_down_icon,
  frame1_icon,
  frame2_icon,
  frame3_icon,
  frame4_icon,
  news_icon,
  Vector_icon,
  chevron_icon,
  arrow_icon,
  Mask_group_icon,
  group9_icon,
  new_icon,
  grid_icon,
  user_icon,
  Group_icon,
  map_icon,
  clip_icon,
  student_icon,
  logout_icon_svg,
  news_icon_svg,
  mic_icon
};
